import React from 'react';
import { OptionCardGroup, OptionCard, OptionCardContent, scrollToElement } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import MobilePacket from './packet/MobilePacket';
import InternetPacket from './packet/InternetPacket';
import CmsDataStore from '../stores/CmsDataStore';
import { Item } from './packet/types';

interface ChoosePacketsProps {
  label: React.ReactNode;
  dataField: string;
  defaultPackageType: string;
  relatedProductDataField: string;
  items: Item[];
  cmsDataStore?: CmsDataStore;
  nextStepId?: string;
}

@observer
class ChoosePackets extends React.Component<ChoosePacketsProps> {
  public static defaultProps: Partial<ChoosePacketsProps> = {
    dataField: 'selectedPacket',
    defaultPackageType: 'phone',
    relatedProductDataField: 'selectedProduct'
  };

  private areAllItemsSameType(items: Item[]) {
    const itemType = items[0].type;
    return !items.some((item) => item.type && item.type !== itemType);
  }

  private resolvePacketType() {
    const { cmsDataStore, items, dataField, relatedProductDataField, defaultPackageType } = this.props;
    const selectedProduct = cmsDataStore.getData(relatedProductDataField);
    const chosenType = cmsDataStore.getData(`${dataField}Type`);
    if (selectedProduct && selectedProduct.type) {
      return selectedProduct.type;
    } else if (chosenType) {
      return chosenType;
    } else if (items.length > 0 && this.areAllItemsSameType(items)) {
      return items[0].type;
    }
    return defaultPackageType;
  }

  private filterPacketItems() {
    const selectedProductType = this.resolvePacketType();
    return this.props.items.filter((item) => !item.type || item.type === selectedProductType);
  }

  private renderPacketItem(item: Item, selectedPacketId: string) {
    const { cmsDataStore, dataField, nextStepId } = this.props;
    const { id, title, type, tag, badge, ...rest } = item;
    const selected = selectedPacketId === id;
    const itemType = type || this.props.defaultPackageType;
    return (
      <OptionCard
        {...rest}
        key={id + title}
        id={id}
        value={id}
        inputType="radio"
        labelText={title}
        onChange={() => {
          cmsDataStore.setData(dataField, item);
          cmsDataStore.setData(`${dataField}Name`, item.title);

          if (nextStepId) {
            scrollToElement(nextStepId);
          }
        }}
      >
        <OptionCardContent tagTop={tag ?? badge ?? true}>
          {itemType !== 'phone' ? (
            <InternetPacket item={item} selected={selected} dataField={dataField} />
          ) : (
            <MobilePacket item={item} selected={selected} dataField={dataField} />
          )}
        </OptionCardContent>
      </OptionCard>
    );
  }

  private renderItems() {
    const { cmsDataStore, dataField } = this.props;
    const selectedPacket = cmsDataStore.getData(dataField);
    let selectedPacketId: string | null = null;
    if (selectedPacket) {
      selectedPacketId = selectedPacket.id;
    }
    return this.filterPacketItems().map((item) => this.renderPacketItem(item, selectedPacketId));
  }

  public render() {
    const { cmsDataStore, dataField, label } = this.props;
    const selectedPacket = cmsDataStore.getData(dataField);
    let selectedPacketId: string | null = null;
    if (selectedPacket) {
      selectedPacketId = selectedPacket.id;
    }

    return (
      <OptionCardGroup
        label={label}
        inputType="radio"
        value={selectedPacketId}
        // Force to be controlled, value setting is handled in OptionCard onChange.
        onChange={() => {}}
        name={dataField}
        gridColumn={{
          width: ['xs-12', 'sm-6', 'md-3']
        }}
      >
        {this.renderItems()}
      </OptionCardGroup>
    );
  }
}

export default inject('cmsDataStore')(ChoosePackets);
